import { ccpAudioChatClient } from '@/api/axios';
import type { IContact } from '@/types/contact';
import type { IGetRecordingResp, IJoinInfo, ISmsError, IStartAudioChatMeetingResp } from '@/types/audioChat';
import { showErrorToastMessage, showSuccessToastMessage } from '@/utils/toastMessage';

export const startAudioChatMeeting = async (
  currentContactGetter: IContact,
  firstCall: boolean
): Promise<IStartAudioChatMeetingResp> => {
  const {
    externalMeetingId,
    externalUserId,
    contactUsername,
    contactEmailUppercase,
    agentUsername
  } = currentContactGetter;

  const body = {
    externalMeetingId: externalMeetingId,
    meetingTitle: externalMeetingId,
    meetingRegion: 'eu-central-1',
    meetingAttendees: [
      {
        attendeeName: contactUsername,
        attendeeEmail: contactEmailUppercase,
        externalUserId: externalUserId,
        isOwner: true
      },
      { attendeeName: agentUsername }
    ],
    firstCall
  };

  const { data } = await ccpAudioChatClient.post<IStartAudioChatMeetingResp>('/meeting', body);

  return data;
};

export const getRecording = async (
  agentUsername: string
): Promise<IGetRecordingResp> => {
  const { data } = await ccpAudioChatClient.get<IGetRecordingResp>(`/getrecording/${agentUsername}`);

  return data;
};

export const startRecordingMeeting = async (
  meetingId: string
): Promise<{
  MediaPipelineId: string;
  MediaPipelineArn: string
}> => {
  const body = {
    meetingId
  };

  const { data } = await ccpAudioChatClient.post<{MediaPipelineId: string; MediaPipelineArn: string}>('/startrecording', body);

  return data;
};

export const startRecordingConcatenation = async (
  currentContactGetter: IContact
): Promise<void> => {
  const { chimeMeeting, Frazionario, contactPDL, contactId, contactEmail, agentUsername } = currentContactGetter;

  const { mediaPipelineArn, userAttendeeId } = chimeMeeting;

  const body = {
    mediaPipelineArn: mediaPipelineArn,
    agentId: agentUsername,
    username: contactEmail,
    frazionario: Frazionario,
    pdl: contactPDL || 'noPDL',
    contactId: contactId,
    attendeeId: userAttendeeId
  };

  const { data } = await ccpAudioChatClient.post<void>('/startconcatenation', body);

  return data;
};

export const stopRecordingMeeting = async (
  currentContactGetter: IContact
): Promise<void> => {
  const { chimeMeeting, contactId } = currentContactGetter;
  const { mediaPipelineId } = chimeMeeting;
  const { meeting } = chimeMeeting;
  const { MeetingId } = meeting as IJoinInfo['Meeting'];

  const body = {
    mediaPipelineId,
    contactId,
    meetingId: MeetingId
  };

  const { data } = await ccpAudioChatClient.post<void>('/stoprecording', body);

  return data;
};

export const downloadRecordingVideo = async (
  link: string
): Promise<string> => {
  const { data } = await ccpAudioChatClient.get<string>('/videodownload',
    {
      params: {
        path: link
      }
    });

  return data;
};

export const updateAudioChatLog = async (
  contactId: string,
  type: string
) => {
  const body = {
    type
  };

  const { data } = await ccpAudioChatClient.put<void>(`/updateVideoCall/${contactId}`, body);

  return data;
};

export const checkRecording = async (
  meetingId: string
): Promise<{MediaPipelineArn: string, MediaPipelineId: string}> => {
  const { data } = await ccpAudioChatClient.get<{MediaPipelineArn: string, MediaPipelineId: string}>(`/meeting/${meetingId}`);

  return data;
};

export const sendSms = async (
  text: string, destinationNumber: string
): Promise<void> => {
  try {
    const body = {
      text,
      destinationNumber
    };

    const { data } = await ccpAudioChatClient.post<{success: string}>('/sendsms', body);
    const { success } = data;

    showSuccessToastMessage(success);
  } catch (error) {
    console.log('sono error', error);
    const { response } = error as ISmsError;

    showErrorToastMessage(`Messaggio non inviato [ ${response.data.message} ]`);
  }
};
